// Copyright (c) Docugami, Inc. All rights reserved.

import { useAppSelector } from "hooks/redux";
import React, { useContext, useMemo } from "react";

export interface IWorkPathCache {
    id: string;
    scrollState: Record<string, number>
};

const createWorkPathCache = (id: string): IWorkPathCache => ({
    id: id,
    scrollState: {}
});

export const WorkPathCacheContext = React.createContext<IWorkPathCache | null>(null);

export const useWorkPathCacheContextProvider = () => {
    const currentId = useAppSelector(state => state.workPaths.currentWorkPath?.id);
    return useMemo(() => createWorkPathCache(currentId ?? ''), [currentId]);
}

export const useWorkPathCache = () => useContext(WorkPathCacheContext);
